import { ReactNode } from 'react'

/** Admin page header: 20px title, muted subtitle, actions on the right. */
export const PageHeader = ({ title, subtitle, children }: { title: string; subtitle?: string; children?: ReactNode }) => (
  <header className="flex flex-wrap items-center gap-3 border-b border-border px-4 py-4 md:px-6">
    <div className="min-w-48 flex-1">
      <h1 className="text-heading-lg text-ink">{title}</h1>
      {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
    </div>
    {children}
  </header>
)
